/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved. */
import {
    Polymer,
    html
} from '@polymer/polymer/polymer-legacy.js';
/* This polymer element displays offer available to a particular user.*/

const template = html `
            <style include="app-styles">
            .min-height{
				min-height:100px;
			}
            paper-carousel{
                z-index:0;
            }
           .cardImg {
                max-width: 100%; 
                height: auto;
            }
		</style>

		<template is="dom-if" if="{{offersAvailable}}">

            <template is="dom-if" if="{{dashboardOffersLoader}}">
                <div class="mdl-grid padding-b-zero">
                    <div class="mdl-cell mdl-cell--12-col secondary-dark-text-m font-medium">
                        &nbsp;
                    </div>
			    </div>
                <div class="min-height horizontal center-center layout">
                    <paper-spinner id="dashboard_offers_spinner" active></paper-spinner>
                </div>
			</template>

            <template is="dom-if" if="{{!dashboardOffersLoader}}" restamp=true>
                <paper-carousel id="dashboard_offers_carousel" items="1" controls="false" dotText="false" dots="true">
                    <template is="dom-repeat" items="{{offers}}" as="offer">
                        <div>
                            <a tabindex=-1 href="{{offer.offerTargetURL}}">
                                <img alt="{{getLabel("h_Offer")}}" class="cardImg" aria-label$="{{getLabel("h_Offer")}}" role="banner" src="{{offer.offerBannerImageURL}}">
                            </a>    
                        </div>
                    </template>
                </paper-carousel>
            </template>

		</template>`;


Polymer({
    is: 'dashboard-user-offers',
    _template: template,
    properties: {
         /**
       * offers list 
       * @type {{level: Array}}
       */
        offers: {
            type: Array,
            notify: true,
            observer: '_offersChanged'
        },
        /**
        * Boolean variable denotes availability of offers
        * @type {{level: boolean}}
        */
        offersAvailable: {
            type: Boolean,
            value: true,
            notify: true
        },
        /**
        * Boolean variable for loader
        * @type {{level: boolean}}
        */
        dashboardOffersLoader: {
            type: Boolean,
            value: true,
            notify: true
        }
    },
    
    /* @event _offersChanged
    * event fired when offers change
    */
    
    _offersChanged: function () {
        if (this.offers != undefined) {
            if (this.offers.length <= 0)
                this.offersAvailable = false;
            this.$$("#dashboard_offers_spinner").active = false;
            this.dashboardOffersLoader = false;
            /* paper-carousel element is not available in Polymer3. Below code is removed untill a replacement element is added.
                    setTimeout(function(){
                        if(self.$$("#dashboard_offers_carousel"))
                            self.$$("#dashboard_offers_carousel").refresh();
                    },100);
            */
        }
    }

});